export default {
      id: "i-sber-usage",
      viewBox: "0 0 56 56",
      url: __webpack_public_path__ + "img/sprite.svg#i-sber",
      toString: function () {
        return this.url;
      }
    }